import { Send } from 'lucide-react';
import React from 'react';

interface AlertMessageProps {
  title: string;
  message: string;
  icon?: { icon: React.ReactElement<any>; color?: string };
  toggle?: () => void;
  closeButton?: boolean;
}

const AlertMessage: React.FC<AlertMessageProps> = ({
  title,
  message,
  toggle,
  icon,
  closeButton,
}) => {
  const toggleModal = () => {
    if (toggle) {
      toggle();
    }
  };

  return (
    <div>
      <div className="flex justify-center flex-col items-center text-center gap-y-5">
        <div
          className={`mt-2 rounded-full ${
            icon?.color ? icon.color : 'bg-green-200'
          } text-gray-800 p-5 ring-8 ring-green-50`}
        >
          {icon?.icon ? <>{icon.icon}</> : <Send className="size-6" />}
        </div>

        <h3 className="text-xl font-bold text-gray-800">{title}</h3>
        <p className="text-base text-gray-800 ">{message}</p>

        {closeButton !== false && (
          <button
            type="button"
            className="py-3 px-5 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white shadow-xs hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none"
            onClick={() => toggleModal()}
          >
            Close
          </button>
        )}
      </div>
    </div>
  );
};

export default AlertMessage;
